// page.tsx
"use client";

import { useState, Suspense, lazy } from "react";
import LockScreen from "../../Components/Lockscreen";
import "./TimeSquare.css";

import { TimeSquareMail } from "./TimeSquareAssets/TimeSquareMailContent";
import { TimeSquareNoteContent } from "./TimeSquareAssets/TimeSquareNoteContent";
import { TimeSquareMessageContent } from "./TimeSquareAssets/TimeSquareMessagesContent";
import { TimeSquareCallContent } from "./TimeSquareAssets/TimeSquareCallContent";
import { Chat_content } from "../../Components/MessageApp/MessagesInterfaces";
import { TimeSquareTweetContent } from "./TimeSquareAssets/TimeSquareTweeterContent";
import CallApp from "../../Components/CallApp/CallApp";
import { TimeSquarePhotoContent } from "./TimeSquareAssets/TimeSquarePhotoContent";
import { TimeSquareInternetContent } from "./TimeSquareAssets/TimeSquareInternetContent";
import { TimeSquareNYGirls } from "./TimeSquareAssets/TimeSquareNYGirlsContent";
import HomeIcon from "../../Components/Icons/HomeIcon";
import TheGramApp from "../../Components/TheGramApp/TheGramApp";
import { TimeSquareTheGramContent } from "./TimeSquareAssets/TimeSquareGramContent";
import LockScreenWrapper from "../../Components/LockScreenWrapper/LockScreenWrapper";

const Messages = lazy(() => import("../../Components/MessageApp/Messages"));
const Photos = lazy(() => import("../../Components/PhotosApp/Photos"));
const AppsMenu = lazy(
  () => import("../../Components/AppsMenu/AppsMenuTimeSquare")
);
const NotesApp = lazy(() => import("../../Components/NotesApp/NotesApp"));
const TweeterApp = lazy(() => import("../../Components/TweeterApp/TweeterApp"));
const InternetApp = lazy(
  () =>
    import("../../Components/InternetApps/TimeSquareInternetApp/InternetApp")
);
const MailApp = lazy(() => import("../../Components/MailApp/MailApp"));

function TimeSquare() {
  const [isLocked, setIsLocked] = useState(true);
  const [activeApp, setActiveApp] = useState("appsmenu");
  const [messages, setMessages] = useState(TimeSquareMessageContent);
  const [messageNotifications, setMessageNotifications] = useState(0);

  const unlock = () => {
    setIsLocked(false);
  };

  const handleStateChange = (chat: Chat_content) => {
    const chatIndex = messages.findIndex(
      (message) => message.name === chat.name
    );
    const previousMessage = messages[chatIndex];
    if (previousMessage && !previousMessage.read) {
      const newMessages = [...messages];
      newMessages[chatIndex] = {
        ...newMessages[chatIndex],
        read: true,
      };
      setMessages(newMessages);
      setMessageNotifications(messageNotifications - 1);
    }
  };

  const renderApp = () => {
    switch (activeApp) {
      case "messages":
        return (
          <Messages
            influencerMessageContent={messages}
            theGram={false}
            handleStateChange={handleStateChange}
          />
        );
      case "nygirls":
        return (
          <LockScreenWrapper password="020498">
            <Messages
              influencerMessageContent={TimeSquareNYGirls}
              theGram={false}
              handleStateChange={handleStateChange}
            />
          </LockScreenWrapper>
        );
      case "phone":
        return <CallApp callContent={TimeSquareCallContent} />;
      case "photos":
        return <Photos albums={TimeSquarePhotoContent} />;
      case "notes":
        return <NotesApp noteContent={TimeSquareNoteContent} />;
      case "appsmenu":
        return (
          <AppsMenu
            isLocked={isLocked}
            setActiveApp={setActiveApp}
            messageNotifications={messageNotifications}
          />
        );
      case "tweeter":
        return <TweeterApp tweeterContent={TimeSquareTweetContent} />;
      case "mail":
        return <MailApp emails={TimeSquareMail} />;
      case "thegram":
        return (
          <TheGramApp content={TimeSquareTheGramContent} notifications={0} />
        );

      case "internet":
        return <InternetApp {...TimeSquareInternetContent} />;

      default:
        return null;
    }
  };

  return (
    <div className="Mystery">
      <div className="phone-wrapper">
        <div className={`TimeSquarescreen ${activeApp}`}>
          {isLocked ? (
            <div
              className={`lockscreen-container ${
                isLocked ? "visible" : "hidden"
              }`}
            >
              <LockScreen
                unlock={unlock}
                password="030997"
                className="TimeSquareLockscreen"
              />
            </div>
          ) : null}

          <Suspense
            fallback={
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                Loading...
              </div>
            }
          >
            {renderApp()}
          </Suspense>
          <div className="home-button-container">
            <HomeIcon onClick={() => setActiveApp("appsmenu")} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default TimeSquare;
